// พิกัดของ PDF Editor
//
// "native" = พื้นที่หน้ากระดาษก่อนหมุน (กว้าง W × สูง H หน่วย pt, ต้นทางมุมบนซ้าย, แกน y ชี้ลง)
//            ออบเจกต์ทุกชิ้นเก็บพิกัดเป็น native เพื่อให้ตรงกับ PDF user space ไม่ว่าหน้าจะหมุนกี่องศา
// "visible" = สิ่งที่ผู้ใช้เห็นบนจอหลังหมุนทั้งหมด R องศา (หมุนเดิมของไฟล์ + ที่ผู้ใช้หมุน) ตามเข็มนาฬิกา
//
// ออบเจกต์มี x,y = มุมบนซ้ายของกล่อง (native), w,h = ขนาดในแกนของตัวเอง, rot = หมุนตามเข็มนาฬิการอบมุมบนซ้าย
// ตอนสร้างตั้ง rot = -R เพื่อให้ตั้งตรงในมุมมองที่ผู้ใช้เห็น

export const TEXT_ASCENT = 1.068; // Sarabun: ascent (em) -> baseline ของบรรทัดแรก
export const TEXT_LINE_HEIGHT = 1.3; // ascent 1.068 + descent 0.232

export const normRot = (deg) => ((Math.round(deg) % 360) + 360) % 360;

// ขนาดที่เห็นบนจอ
export const visibleSize = (W, H, R) => (R % 180 === 0 ? { w: W, h: H } : { w: H, h: W });

// จุด visible -> native
export const visibleToNative = (x, y, W, H, R) => {
  switch (normRot(R)) {
    case 90: return { x: y, y: H - x };
    case 180: return { x: W - x, y: H - y };
    case 270: return { x: W - y, y: x };
    default: return { x, y };
  }
};

// จุด native -> visible
export const nativeToVisible = (a, b, W, H, R) => {
  switch (normRot(R)) {
    case 90: return { x: H - b, y: a };
    case 180: return { x: W - a, y: H - b };
    case 270: return { x: b, y: W - a };
    default: return { x: a, y: b };
  }
};

// เวกเตอร์ visible -> native (ใช้กับ delta ของการลาก)
export const visibleVecToNative = (dx, dy, R) => {
  switch (normRot(R)) {
    case 90: return { x: dy, y: -dx };
    case 180: return { x: -dx, y: -dy };
    case 270: return { x: -dy, y: dx };
    default: return { x: dx, y: dy };
  }
};

// หมุนเวกเตอร์ตามเข็มนาฬิกา (บนแกน y ชี้ลง) deg องศา
export const rotateVec = (x, y, deg) => {
  const r = (deg * Math.PI) / 180;
  const c = Math.cos(r);
  const s = Math.sin(r);
  return { x: x * c - y * s, y: x * s + y * c };
};

// จุด native -> PDF user space (cx,cy = มุมล่างซ้ายของ cropbox, H = สูงของ cropbox)
export const nativeToPdf = (a, b, box) => ({ x: box.x + a, y: box.y + box.height - b });

// จุดในแกนของออบเจกต์ (lx,ly) -> native
export const localToNative = (obj, lx, ly) => {
  const v = rotateVec(lx, ly, obj.rot || 0);
  return { x: obj.x + v.x, y: obj.y + v.y };
};

export const totalRotation = (page) => normRot((page.baseRotation || 0) + (page.userRotation || 0));

// วางกล่องโดยให้มุมบนซ้ายที่ผู้ใช้เห็นอยู่ที่ (vx,vy) และตั้งตรงในมุมมองที่เห็น
export const placeAtVisible = (vx, vy, W, H, R) => {
  const n = visibleToNative(vx, vy, W, H, R);
  return { x: n.x, y: n.y, rot: normRot(-R) };
};
